import request from '@/utils/request'
//记录用户动作
export function customerActionLog(data) {
  return request({
    url: '/user/kycCert/customerActionLog',
    method: 'POST',
    data
  })
}
